import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { fetchUserProductMembership } from 'store/actions/users/product-memberships/fetchUserProductMemberships';
import utils from 'helpers/utils';
import UserProductMembershipForm from '../UserProductMembershipForm';
import { updateUserProductMembership } from 'store/actions/users/product-memberships/updateUserProductMembership';
import fetchResourceById from 'components/hoc/fetchResourceById';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import LoadingCard from 'components/loading/LoadingCard';
import { fetchUser } from 'store/actions/users/fetchUsers';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import translate from 'components/hoc/translate';
import InnerColumn from 'components/ui/show/InnerColumn';
import Column from 'components/ui/show/Column';
import Section from 'components/ui/general/Section';
import Title from 'components/ui/general/Title';
import Header from 'components/ui/general/Header';
import { fetchProductMembership } from 'store/actions/product-memberships/fetchProductMemberships';

class UserProductMembershipsEditContainer extends Component {
    componentDidMount() {
        this.props.dispatchFetch();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialValues.product_membership_id !== this.props.initialValues.product_membership_id) {
            this.props.dispatchFetchProductMembership(this.props.data.product_membership_id);
        }
    }

    dispatchForm = (values) => {
        const {
            data,
            id,
            history,
            membershipId,
            dispatchForm,
        } = this.props;

        const paymentMethod = values.payment_method ? 'deferred' : 'invoice';

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: reject,
                onSuccess: () => {
                    resolve(history.push(`/users/${ id }/show`));
                },
                id: membershipId,
                values: utils.diffObjects(data, {
                    ...values,
                    payment_method: paymentMethod,
                }),
            });
        });
    }

    render() {
        const {
            data,
            membershipId,
            resourceFetchFailed,
            resourceFetchLoading,
            user,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = generateBreadcrumbsFromPath({
            users: translate('resources.users.title'),
            [user.id]: {
                ...user,
                name: utils.fullName(user.first_name, user.last_name),
            },
            'product-memberships': translate('resources.product_memberships.title'),
            [membershipId]: membershipId,
        }, this.props);

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.users.product_memberships.actions.edit') } />
                </Header>

                <Section>
                    <Column>
                        <InnerColumn>
                            <UserProductMembershipForm
                                initialValues={ {
                                    ...data,
                                    payment_method: data.payment_method === 'deferred',
                                } }
                                form='user-product-membership-edit'
                                onSubmit={ this.dispatchForm }
                            />
                        </InnerColumn>
                    </Column>
                </Section>
            </div>
        );
    }
}

UserProductMembershipsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchFetch: PropTypes.func.isRequired,
    dispatchFetchProductMembership: PropTypes.func.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
        product_membership_id: PropTypes.number,
    }).isRequired,
    membershipId: PropTypes.number.isRequired,
    resourceFetchFailed: PropTypes.bool,
    resourceFetchLoading: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const {
        'product-memberships': { data: productMemberships = {} },
        userProductMemberships: { data: userProductMemberships = {} },
    } = state;

    const {
        data: user,
        membershipId,
    } = props;

    const initialValues = userProductMemberships[membershipId] || {};

    const productMembership = productMemberships[initialValues.product_membership_id] || null;

    if (productMembership) {
        initialValues.product_id = productMembership.product_id;
    }

    return {
        data: state.userProductMemberships.data[membershipId] || {},
        initialValues,
        productMembership,
        user: user || {},
        resourceFetchLoading: props.resourceFetchLoading || state.userProductMemberships.loading,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        dispatchFetch: () => {
            dispatch(fetchUserProductMembership({ id: props.membershipId }));
        },
        dispatchForm: (payload) => {
            return dispatch(updateUserProductMembership(payload));
        },
        dispatchFetchProductMembership: (id) => {
            dispatch(fetchProductMembership({ id }));
        },
    };
};

const enhance = compose(
    fetchResourceById({
        resource: 'users',
        action: fetchUser,
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate
);

export default enhance(UserProductMembershipsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/users/product-memberships/edit/UserProductMembershipsEditContainer.js